<script>
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";

import { incomeExpense } from "../../../../services/financeservice/incomeExpense.service";
// import { propertyService } from "../../../../services/propertyservice/property.service";
import { projectService } from "../../../../services/projectservice/project.service";
import { servicehelpers } from "../../../../services/servicehelpers";"../../../../services/propertyservice/property.service";

import List from "../../../../components/list";
import i18n from "../../../../i18n";
/* eslint-disable no-console */
/**
 * Contacts-list component
 */
export default {
  page: {
    title: "Expense List",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader, List },
  data() {
    return {
      incomeList: {},
      fetchingStats: false,
      title: "incomeTemplates List",

    };
  },
  mounted() {
    
    this.loadingData();
    this.loadingprojectData();
  },

  methods: {
    
    loadingData: function(param = '') {
      let uri = `&clause={"clause":[{"conjuction":"and","income_expenses.type":{"value":1}}]}`;
      param = param ? param + uri : `?page=1`+uri;


      this.fetchingStats = false;
      incomeExpense.getList(param)
        .then(response => {
          
          this.fetchingStats = true;
          this.incomeList = response;
        });
    },

    projectChanged: function(event) {
      this.loadingpropertyFloorData(event);
      this.loadingpropertyGroupData(event);
    },

    loadingprojectData: function() {
      projectService.getList()
        .then(response => {
          this.projectData = response;

        });
    },

    loadingpropertyFloorData: function(projectId = 0) {
      servicehelpers.getFloorData(projectId).then(response => {
        this.floorData = response;
      });
    },

    loadingpropertyGroupData: function(projectId = 0) {
      servicehelpers.getGroupData(projectId).then(response => {
        this.groupData = response;
      });
    },

    deleted: function(id) {
      incomeExpense.remove(id)
        .then(response => {
        
          // this.customerData = response;
          if(response.status == 200) {
            this.$swal.fire({
              title: i18n.t('general.confirm.deleted'),
              text: i18n.t('general.confirm.success'),
              icon: "success",
              confirmButtonText: i18n.t('general.ok')
            });
          }
        });
    },

    pageNavigate: function(param) {
      this.loadingData(param);
    },

    submitAdd: function() {
      this.$router.push(this.$route.query.redirectFrom || {
              name: "expense-add",
          });
    },

  }
};

// v-bind:edit="{link: 'income-edit'}"
</script>

<template>
  <Layout>
    <PageHeader :add="{icon: 'bx bx-add-to-queue bx-tada', title: 'income.add', link: 'income-add'}" :title="$t('income.text')" />
    <List v-bind:dataList="incomeList" 
          v-bind:updating="fetchingStats" 
          v-bind:navigate="pageNavigate"
          v-bind:deletes="[deleted, null]"
          v-bind:formats="[
            {name: 'item'}, 
            {name: 'for_date', type: 'date'},
            {name: 'received_date', type: 'date'},
            {name: 'amount', type: 'currency', sign: '$'}, 
          ]"
          v-bind:fields="[ 
            `project_code: ${$t('project.text')}`,
            `ref_no: ${$t('income.ref_no')}`,
            `for_date: ${$t('income.date')}`,
            `received_date: ${$t('income.received_date')}`,
            `amount: ${$t('income.amount')}`,
            `item: ${$t('income.item-type')}`
          ]"

          v-bind:filter="{
            search: ['income_expenses.ref_no'],
            dropdown:[],
            date: {
              title: 'income.date',
              field: 'income_expenses.for_date'
            }
          }"
          
    />      
  </Layout>
</template>